/**
 * 创建人：王靖
 * 时间：2019-6-14
 * 描述：树形组件
 * 使用说明: 参考 sw-tree 配置应用说明文档
 * 更新记录: 
 * 1.新增最底层节点多选功能和所有节点多选功能 by yuanjs 2019-8-21
 */
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { SwTreeNodeOptions } from './sw-tree-node/sw-tree-node';
import { SwTreeService } from './sw-tree.service';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { SystemIdService } from 'src/app/librarys/serves/public/system-id.service';

/**
 * 树列表组件 sw-tree
 */
@Component({
  selector: 'sw-tree',
  templateUrl: './sw-tree.component.html',
  styleUrls: ['./sw-tree.component.css']
})
export class SwTreeComponent {
  /**
   * 传入的树数据 格式{id: "1", text: "content", pid: "0",expanded:'true'}
   */
  @Input() datas: any[];

  /**
   * 传入的地址如果为bdp相关，需要再请求中加入此参数
   */
  @Input() isAdminQuery: boolean;
  /**
   * 选中的key值， 传入选中的Id值 
   */
  @Input() keySelected: string;

  /**
   * 选中的key值，仅限于sw-tree组件使用,不能用在sw-tree-select中 传入选中的Id值 ,
   * 或者传 'default',默认选中第一个(未被只读和禁用)节点,且会将该节点抛出,
   * 该属性与 keySelected 不同之处在于,一开始都可以有选中样式,但是 keySelected 选中的节点一开始不会抛出,之后点击选中会抛出,
   * 而 initSelectedId 已开始就可以选中且抛出改节点,针对抛出的节点页面可以进行相关初始化的操作,之后再点击选中节点,就与它无关了
   */
  @Input() initSelectedId: string;

  /**
   * 异步加载的请求地址，没有则为同步加载
   */
  @Input() asyncNodeUrl: string;

  /**
   * 异步请求的方式，针对部分请求数据不一的树
   */
  @Input() asyncParams: string;

  /**
   * 异步请求 主键输入
   */
  @Input() id: string;

  /**
   * 异步请求 父节点输入
   */
  @Input() pid: string;

  /**
   * 节点类型输入 1,文件类型  2,用户类型 , 现在还只是在用户管理中用到, 根据positionId判断,如果positionId存在, iconType 就为2 , 没有就为1
   */
  @Input() type: string;
  /**
 * 显示类型 1，超出长度自动隐藏
 */
  @Input() showType: string;

  /**
   * 异步请求 显示输入
   */
  @Input() text: string;

  /**
   * 父节点的值 用于异步 默认为0
   */
  @Input() parentId: string;

  /**
   * 是否展开第一节节点
   */
  @Input() isOneOpen: boolean = false

  /**
   * 不要展示的节点(包括其子节点)的id字符串,用来解决bug: 禁止将自己的上级修改为子级的现下级及其本身，当字典数据为禁用时 下拉不显示
   */
  @Input() disabledNodeId: string = ""

  /**
   * 能展示但是不能选择的节点(包括其子节点)的id
   */
  @Input() readonlyNodeId: any[] = []

  /**
   * 能展示但是不能选择的节点(不包括其子节点)的id
   */
  @Input() readonlySelfId: any[] = []

  /**
   * 传出选中的节点
   */
  @Output() voted = new EventEmitter();

  /**
   * 同步默认打开到第几节点
   */
  @Input() openNode: number;

  /**
   * 最底层节点带复选框
   */
  @Input() selectChildren: boolean = false;

  /**
   * 所有节点带复选框
   */
  @Input() allCanCheck: boolean = false;

  /**
   * 复选功能回显的id
   */
  @Input() multiNodeIds: any[] = [];

  /**
  * 是否显示岗位
  */
  @Input() showPos: boolean = true;

  /**
  * isPid0 在datas有值时，判断是否只显示根节点的pid和parentId为0的数据
  */
  @Input() isPid0: boolean = false;

  /**
   * 点击节点的时候是否抛出该节点的及其所有父级的信息（仅支持单选）
   * @ignore
   */
  @Input() allPath: boolean = false

  /**
   * @ignore
   * 被选中的带复选框的最底层节点
   */
  multiNodes: any[] = []

  /**
   * 树结构绑定数据
   * @ignore
   */
  nodes: any = [];

  /**
   * 当前点击节点的父节点
   * @ignore
   */
  parent: any[] = []

  /**
   * 父节点是否需要选中,假设是
   * @ignore
   */
  check: boolean = true

  /**
   * @ignore
   * @param swTreeService  树服务
   * @param http  http请求 
   * @param system  系统id
   */
  constructor(private swTreeService: SwTreeService, private http: SwHttpClientService,
    private system: SystemIdService) { }

  /**
   * @ignore
   * 系统id
   */
  systemId = this.system.getSystemId();

  /**
   * @ignore
   */
  ngOnInit(): void {
    this.location();
  }

  /**
   * 重新加在异步请求
   */
  location() {
    this.systemId = this.system.getSystemId();
    if (this.asyncNodeUrl) {
      this.nodes = [];
      if (this.parentId == null || this.parentId == undefined) {
        this.parentId = "0"
      }
      //默认获取主节点 parentId 默认为0
      let str = `{"entity":{"${this.pid}":"${this.parentId}", "systemId": "${this.systemId}"},"param":{"pageSize":0}}`;
      if (this.isAdminQuery == true) {
        str = `{"entity":{"${this.pid}":"${this.parentId}", "systemId": "${this.systemId}"},"param":{"pageSize":0,"isAdminQuery":true}}`;
      }
      let params = JSON.parse(str);

      //获取主节点数据
      this.http.Post(this.asyncNodeUrl, params).subscribe(data => {
        console.log(data.data.records)
        //判断是不是默认展开第一节点
        if (this.isOneOpen) {
          let index = 0; //指示当前是第几个节点,执行一次循环后累加
          data["data"]["records"].forEach(dt => {
            //如果是默认展开下级 在往下查一级数据
            let str = `{"entity":{"${this.pid}":"${data["data"]["records"][index][this.id]}", "systemId": "${this.systemId}"},"param":{"pageSize":0}}`;
            if (this.isAdminQuery == true) {
              str = `{"entity":{"${this.pid}":"${data["data"]["records"][index][this.id]}", "systemId": "${this.systemId}"},"param":{"pageSize":0,"isAdminQuery":true}}`;
            }

            //先将第一层节点放入数组，以免后面post异步导致顺序每次不一致
            let node = new SwTreeNodeOptions();
            //填充主节点的数据
            node.key = dt[this.id];
            node.title = dt[this.text];
            node.parent = dt[this.pid];
            node.data = dt;
            let t = dt[this.type] ? 2 : 1
            node.iconType = t;
            node.expanded = this.isOneOpen;
            if (dt.positionId) {
              node.type = 2
            } else {
              node.type = 1
            }
            //单选功能的回显
            if (!node.multiple && !node.checkbox && !node.readonly && !node.disabled && this.initSelectedId) {
              if (this.initSelectedId && this.initSelectedId == 'default') {
                //默认选中第一个节点
                node.selected = true
                this.initSelectedId = ""  //将默认选中节点清空
              } else if (this.initSelectedId && this.initSelectedId != 'default') {
                node.selected = this.initSelectedId == node.key
              }
            }

            node.children = [];

            let params = JSON.parse(str);

            //如果展示岗位则加入数组
            if (this.showPos == true) {
              this.nodes.push(node);
            } else if (node.type == 1) {
              this.nodes.push(node);
            }

            this.http.Post(this.asyncNodeUrl, params).subscribe(el => {

              //然后加载填充下一级的数据
              if (el["data"]["records"] != null) {

                let nds: any = [];
                el["data"]["records"].forEach(e => {
                  let nd: any = {};
                  nd.key = e[this.id];
                  nd.title = e[this.text];
                  nd.parent = e[this.pid];
                  nd.data = e;
                  let t = e[this.type] ? 2 : 1
                  nd.iconType = t;
                  nd.expanded = e["expanded"];
                  //nd.type=e["positionId"];
                  if (e["positionId"]) {
                    nd.type = 2
                  } else {
                    nd.type = 1
                  }

                  //单选功能的回显
                  if (!nd.multiple && !nd.checkbox && !nd.readonly && !nd.disabled && this.initSelectedId) {
                    if (this.initSelectedId && this.initSelectedId == 'default') {
                      //默认选中第一个节点
                      nd.selected = true
                      this.initSelectedId = ""  //将默认选中节点清空
                    } else if (this.initSelectedId && this.initSelectedId != 'default') {
                      nd.selected = this.initSelectedId == nd.key
                    }
                  }

                  nd.children = [];
                  //如果展示岗位则加入数组
                  if (this.showPos == true) {
                    nds.push(nd);
                  } else if (nd.type == 1) {
                    nds.push(nd);
                  }
                });
                //找到对应元素赋予子集
                this.nodes.filter(x => x.key == nds[0].parent)[0].children = nds;
              }

            })
            index++;
          })
        } else {
          //如果不展开下级，直接获取主菜单
          data["data"]["records"].forEach(el => {
            let node = new SwTreeNodeOptions();
            node.key = el[this.id];
            node.title = el[this.text];
            node.expanded = el["expanded"];
            node.data = el;
            let t = el[this.type] ? 2 : 1
            node.iconType = t;

            //单选功能的回显
            if (!node.multiple && !node.checkbox && !node.readonly && !node.disabled && this.initSelectedId) {
              if (this.initSelectedId && this.initSelectedId == 'default') {
                //默认选中第一个节点
                node.selected = true
                this.initSelectedId = ""  //将默认选中节点清空
              } else if (this.initSelectedId && this.initSelectedId != 'default') {
                node.selected = this.initSelectedId == node.key
              }
            }

            node.children = [];
            this.nodes.push(node);
          })

        }
      })
    }
  }
  /**
   * 参数发生变化的时候构子
   * @ignore
   */
  ngOnChanges(): void {
    if (this.datas != null || this.datas != undefined) {
      if (this.datas.length != 0) {
        //数据结构处理
        this.nodes = this.swTreeService.toNodeOptions(this.datas, this.keySelected, this.id, this.pid, this.text, this.disabledNodeId, this.readonlyNodeId, this.readonlySelfId, this.openNode, this.selectChildren, this.allCanCheck, this.multiNodeIds, this.type, this.initSelectedId, this.isPid0);
        if (this.nodes.length > 0) {
          //判断是否展开下一级
          if (this.isOneOpen) {
            this.nodes[0].expanded = this.isOneOpen
          }
        }

        //多选功能回显时 , this.multiNodes 数组中的已经选中的数据要手动加进去, 不然再勾选或取消勾选的时候, 抛出的 this.multiNodes 开始是空数组
        if (this.selectChildren || this.allCanCheck) {  //如果启用了多选功能
          this.multiNodes = []
          this.initMultiData(this.nodes)  //初始化多选功能回显数据
        }

      } else {
        this.nodes = [];
      }
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.initSelectedId && this.nodes.length) {
        this.findselectedOne(this.nodes)
      }
    }, 200);
  }

  /**
   * 初始化多选功能回显数据
   * @ignore
   * @param node 
   */
  initMultiData(tree) {
    for (let i = 0; i < tree.length; i++) {
      if (tree[i].selected) {  //只要是已经选中的数据,就加到 this.multiNodes 数组中
        this.multiNodes.push(tree[i])
      }
      if (tree[i].children && tree[i].children.length > 0 && parent.length != 1) {
        this.initMultiData(tree[i].children)
      }
    }
  }


  /**
   * 点击节点触发
   * @ignore
   * @param node 
   */
  onClickVoteds(node: SwTreeNodeOptions): void {
    //将之前选中的节点的选中样式清空
    if (this.keySelected) {
      this.cancelselectedOne(this.keySelected, this.nodes)

    }
    //点击输出选中的节点
    this.keySelected = node.key;
    //如果有默认选中节点,就将之清空
    if (this.initSelectedId) {
      this.cancelselectedOne(this.initSelectedId, this.nodes)
      this.initSelectedId = ""
    }
    if (this.allPath) {
      //如果要求抛出该节点及其所有父级，就找到父级，抛出 [自己，父级，父级的父级...]
      this.parent = []
      this.findParent(this.nodes, node)
      node.parentPath = this.parent
      this.voted.emit(node);
    } else {
      //正常抛出该节点
      this.voted.emit(node);
    }
  }

  /**
   * 根据 node 节点，找到该节点的所有父级
   * @param tree 
   * @param node 
   */
  findParent(tree, node) {
    if (node.parent) {
      //找到该节点的所有父级
      for (let i = 0; i < tree.length; i++) {
        if (tree[i].key == node.parent) {  //找到了该节点的父级，如果父级还有父级，就继续找
          this.parent.push(tree[i])  //找到了父级
          if (tree[i]['parent']) {
            this.findParent(this.nodes, tree[i])
          }
        }
        if (tree[i]['children'] && tree[i]['children']['length']) {  //还有子级就递归处理
          this.findParent(tree[i]['children'], node)
        }
      }
    }
  }

  /**
   * 最底层节点多选功能-勾选事件触发
   * @ignore
   * @param node 
   */
  onClickVotedMulti(node: SwTreeNodeOptions) {
    if (node.multiple && node.children.length == 0) {
      this.multiNodes.push(node)
      this.voted.emit(this.multiNodes);
    }
  }

  getmultiNode(node) {
    this.multiNodes = node
  }

  /**
   * 最底层节点多选功能-取消勾选事件触发
   * @ignore
   * @param node 
   */
  onClickVotedMultiCancel(node: SwTreeNodeOptions) {
    if (node.multiple && node.children.length == 0) {
      let delIndex
      this.multiNodes.forEach((sn, i) => {
        if (sn.key == node.key) {
          delIndex = i
        }
      })
      this.multiNodes.splice(delIndex, 1)
      this.voted.emit(this.multiNodes);
    }
  }

  /**
   * 所有节点多选功能-勾选事件触发
   * @ignore
   * @param node 
   */
  onClickCheckNodes(node: SwTreeNodeOptions) {
    if (node.checkbox) {
      this.add(node)  //先把当前节点及其子节点全部选中
      this.isParentChecked(node)  //判断父节点是否需要勾选
      this.voted.emit(this.multiNodes);
    }
  }

  //将勾选的节点以及其所有子节点全部加到数组中,但是已经存在的就不要重新添加了
  add(node) {
    if (node.checkbox) {
      if (this.findDelIndex(node.key) == null) {  //要添加的节点在 this.multiNodes 数组中是否存在
        node.selected = true //不管之前有没有设置selected属性,加到数组之前,都要设置为true
        this.multiNodes.push(node)  //如果不存在就添加
        //当前节点及其它的所有子节点已经选中,下面看当前节点的兄弟节点及其所有死节点是否全部选中,如果是,就要勾选父节点,这种情况下,将父节点抛出就行了
      }
      //如果该节点还有子集,就一起添加
      if (node.children.length) {
        node.children.forEach(child => {
          child.selected = true  //不管之前有没有设置selected属性,加到数组之前,都要设置为true
          this.add(child)  //递归
        })
      }

    }
  }


  /**
  * 判断当前节点的父节点是否需要选中
  * @param node 
  * @ignore
  */
  isParentChecked(node) {
    //1.拿到当前节点的父节点的id
    //将父节点清空(注意,此数组中最多只有一个元素)
    this.parent = []
    //找到当前节点的父节点
    this.findNode(this.nodes, node.parent)
    //如果父节点存在,对父节点的所有子节点是否群补勾选进行判断
    if (this.parent.length == 1) {
      //假设父节点的所有子节点都是勾选状态
      this.check = true
      //根据所有子节点来判断之前假设是否需要修改
      this.isAllChecked(this.parent[0])
      //如果假设成立,父节点需要勾选
      //如果父节点需要选中,就勾选父节点,如果不需要,说明还有其他子节点没有选中,那么改父节点一定没有选中,不用再进行其他操作
      if (this.check) {
        //将父节点及其所有子节点选中,之前已经选中的子节点不会重复选中
        this.add(this.parent[0])
      }
      //对父节点的父节点页进行此操作
      this.isParentChecked(this.parent[0])
    }
  }

  /**
   * 判断传入节点的所有子节点是否都已经勾选（含递归）
   * @param node 
   * @ignore
   */
  isAllChecked(node) {
    node.children.forEach(child => {
      if (!child.selected) {
        this.check = false
      }
      if (child.children && child.children.length > 0) {
        this.isAllChecked(child)
      }
    });

  }

  /**
   * 在树形数据中根据 key 主键值查找节点并返回 
   * @param tree  树形数据
   * @param key  主键值
   * @ignore
   */
  findNode(tree, key) {
    for (let i = 0; i < tree.length; i++) {
      if (tree[i].key == key) {
        this.parent.push(tree[i])
        break
      }
      if (tree[i].children && tree[i].children.length > 0 && parent.length != 1) {
        this.findNode(tree[i].children, key)  //递归查找节点
      }
    }
  }

  /**
   * 所有节点多选功能-取消勾选事件触发
   * @ignore
   * @param node 
   */
  onClickCancelCheckNodes(node: SwTreeNodeOptions) {
    if (node.checkbox) {
      //要删除的节点的索引
      let delIndex = []
      //拿到当前节点及所有子节点的索引
      delIndex = this.delete(node, delIndex)
      //将 delIndex 里面的元素按照降序排序,这样遍历该数组索引删除元素的时候,从后往前删,不会因索引改变而删除错误
      delIndex = delIndex.sort(function (a, b) {
        return b - a
      })
      //开始删除取消勾选的元素
      delIndex.forEach(i => {
        this.multiNodes.splice(i, 1)
      })
      //开始删除当前节点的所有父节点
      this.deleteParent(node)
      //抛出选中的数组
      this.voted.emit(this.multiNodes);
    }
  }

  /**
   * 找到当前节点以及其所有子节点在要数组 this.multiNodes 中的索引,返回值是索引组成的数组
   * @ignore
   * @param node 当前节点
   * @param delIndex   索引组成的数组
   * @return  delIndex    索引组成的数组
   */
  delete(node, delIndex) {
    if (node.checkbox) {
      if (this.findDelIndex(node.key) != null) {
        delIndex.push(this.findDelIndex(node.key))  //将要删除的元素的索引存储起来
      }
      if (node.children.length) {
        node.children.forEach(child => {
          this.delete(child, delIndex)  //递归
        })
      }
    }
    return delIndex
  }

  /**
   * 将当前节点的所有父节点全都取消勾选
   * @ignore
   * @param node 当前节点
   */
  deleteParent(node) {
    //1.拿到当前节点的父节点的id
    //将父节点清空(注意,此数组中最多只有一个元素)
    this.parent = []
    //找到当前节点的父节点
    this.findNode(this.nodes, node.parent)
    //如果找得到父节点
    if (this.parent.length == 1) {
      //判断改父节点是否勾选
      if (this.parent[0].selected) {  //如果是勾选状态,就取消勾选
        this.parent[0].selected = false
        //并将之从 this.multiNodes 数组中删除
        //找到父节点的索引
        let pIndex = this.findDelIndex(this.parent[0].key)
        if (pIndex != null) {  //在抛出数组中存在
          this.multiNodes.splice(pIndex, 1)
        }
      }
      //继续往上找到父节点的父节点,继续此操作]
      this.deleteParent(this.parent[0])
    }
  }

  /**
   * 找到该节点在  this.multiNodes 数组中的索引
   * @ignore
   * @param key  节点的主键值
   * @return 找到就返回对应的索引,找不到就返回null
   */
  findDelIndex(nodeKey) {
    for (let i = 0; i < this.multiNodes.length; i++) {
      if (nodeKey == this.multiNodes[i].key) {
        return i
      }
    }
    return null
  }

  /**
   * 单选功能的回显功能--找到已经选中的那个节点,并将该节点抛出
   * @ignore
   * @param tree  树形数据
   * @param node  找到的选中的节点
   */
  findselectedOne(tree) {
    for (let i = 0; i < tree.length; i++) {
      if (tree[i].selected == true) {
        //点击输出选中的节点
        this.voted.emit(tree[i]);
        break
      } else if (tree[i].children && tree[i].children.length > 0) {
        this.findselectedOne(tree[i].children)  //递归查找节点
      }
    }
  }

  /**
   * 单选功能的回显功能--点击其他节点的时候,将默认选中节点的选中样式清空
   * @ignore
   * @param tree  树形数据
   * @param node  找到的选中的节点
   */
  cancelselectedOne(id, tree) {
    if (id && id == 'default') {
      tree[0].selected = false
    } else if (id && id != 'default') {
      for (let i = 0; i < tree.length; i++) {
        if (tree[i].key == id) {
          //点击输出选中的节点
          tree[i].selected = false
          id = ""
          break
        } else if (tree[i].children && tree[i].children.length > 0) {
          this.cancelselectedOne(id, tree[i].children)  //递归查找节点
        }
      }

    }
  }
}
